/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_FOLLOWUP,
  LOAD_RECORDS_META_DATA,
  UPDATE_FOLLOWUP,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError, 
  loadFollowup,
  loadFollowupError,
  loadFollowupSuccess,
  updateFollowupSuccess,
  updateFollowupError
} from "./actions"

import {
  loadFollowupDetails,
  loadRecordsMetaData,
  updateFollowupStatus,
} from "./remotes"

function* loadFollowupDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadFollowup(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFollowupDetails, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadFollowupSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadFollowupSuccess([]))
          yield put(loadFollowupError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadFollowupSuccess([]))
        yield put(
          loadFollowupError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
     
    
      const employee = yield call(loadRecordsMetaData,
        "all_employee_dropdown_list",
        "post")
   
        const followup = yield call(loadRecordsMetaData, "all_deliverable_followup_reason", "post")
      let recordsMetaData = {
      
      
        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data

              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.empCode.concat(" - ", c.name),
                    value: c._id,

                  }
                )
              )) ||
          [],
          followupReasonOptions:
          (followup &&
            followup.data &&
            followup.data.length > 0 &&
            followup.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: e.reasonName,
                    value: e._id,
                  }
                )
              )) ||
          [],
      }
      console.log(recordsMetaData, "my details")
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* updateStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_FOLLOWUP),
    })
    const { update_details = {} } = update
   // yield call(setSubmitting, true)

    try {
      const result = yield call(updateFollowupStatus, update_details)
      if (result) {
        yield put(updateFollowupSuccess(update_details, "Status Updated Successfully"))
        //yield put(loadRecordsAction(true))
      } else {
        yield put(updateFollowupError("Update Status Records Failed"))
      }
    } catch (error) {
      yield put(
        updateFollowupError(
          (error && error.response && error.response.message) ||
            "Update Status Records Failed"
        )
      )
    } finally {
     // yield call(setSubmitting, false)
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadFollowupDetailsSaga(),
    updateStatusSaga()
  ])
}
